import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useFilters from '../filter/useFilters';
import FiltersWrapper from '../filter/FiltersWrapper';
import ListLoader from './ListLoader';
import ListPod from './ListPod';
import PaginationWrapper from '../pagination/PaginationWrapper';
import { usePagination } from '../pagination/usePagination';
import { navigate, fetchJson, getJsonPath } from '../../utils/util';
import { PAGE_SIZE, DEFAULT_FILTERS, verbiage } from '../../utils/consts';

const ListWrapper = ({ jsonType, onPageChanged, onFilterChanged }) => {
  const [masterData, setMasterData] = useState([]);
  const [path, setPath] = useState('');
  const { firstPartyJsonUrl, thirdPartyJsonUrl } = getJsonPath();

  const fetchMasterData = async function () {
    let masterDate = [];
    if (jsonType === 1) {
      masterDate = await fetchJson(firstPartyJsonUrl);
    } else if (jsonType === 2) {
      masterDate = await fetchJson(thirdPartyJsonUrl);
    } else if (jsonType === 3) {
      const masterDate1 = await fetchJson(firstPartyJsonUrl);
      const masterDate2 = await fetchJson(thirdPartyJsonUrl);
      masterDate = masterDate1.concat(masterDate2);
    }
    setMasterData(masterDate);
  };

  useEffect(() => {
    fetchMasterData();
    if (typeof window !== 'undefined') {
      const { pathname, search } = window.location;
      setPath(`${pathname}${search}`);
    }
  }, []);

  const [selectedFilters, setSelectedFilters] = useState(null);
  const filterNames = [verbiage.OCCASION_FILTER, verbiage.CATEGORIES_FILTER, verbiage.BRAND_FILTER];

  const { filteredData, allFilters } = useFilters({
    masterData,
    filterNames,
    defaultFilters: DEFAULT_FILTERS,
    selectedFilters
  });

  const { paginatedData, currentPage } = usePagination({
    filteredData,
    pageSize: PAGE_SIZE,
    path
  });

  const handlePageChanged = (url) => {
    if (onPageChanged) {
      onPageChanged(url);
    } else {
      setPath(url);
      navigate(url);
    }
  };

  const handleFiltersChange = (filters) => {
    // Go back to page 1 once filter changes applied
    if (typeof window !== 'undefined') {
      let params = new URL(`${window.location.origin}${path}`).searchParams;
      params.delete('Nao');
      const search = params.toString();
      const _path = `${window.location.pathname}?${search}`;
      handlePageChanged(_path);
    }
    setTimeout(() => {
      setSelectedFilters(filters);
    });
    if (onFilterChanged) {
      onFilterChanged();
    }
  };

  const renderPagination = () => {
    return (
      <PaginationWrapper
        href={path}
        listLength={filteredData?.length || 0}
        page={currentPage}
        pageSize={PAGE_SIZE}
        scrollContainer="#giftCardsList"
        onPageChanged={handlePageChanged}
      />
    );
  };
  if (masterData?.length < 1) {
    return <ListLoader />;
  }
  const hasFilters = Object.keys(allFilters || {}).length > 0;

  return (
    <div id="giftCardsList">
      {hasFilters && (
        <div className="sui-my-4">
          <FiltersWrapper
            allFilters={allFilters}
            selectedFilters={selectedFilters}
            total={filteredData?.length}
            onChange={handleFiltersChange}
          />
        </div>
      )}
      <div className="sui-p-2">
        <div
          className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2
        md:sui-grid-cols-3 lg:sui-grid-cols-4 xl:sui-grid-cols-5 sui-gap-8"
          data-testid="plp-list"
        >
          {paginatedData?.map((item) => {
            const configurationId = item?.digital?.configurationId || item?.physical?.configurationId;
            return <ListPod key={configurationId} item={item} />;
          })}
        </div>
      </div>
      <div className="sui-my-4 sui-p-2">{renderPagination()}</div>
    </div>
  );
};

ListWrapper.propTypes = {
  jsonType: PropTypes.number,
  onPageChanged: PropTypes.func,
  onFilterChanged: PropTypes.func
};

ListWrapper.defaultProps = {
  jsonType: 3,
  onPageChanged: undefined,
  onFilterChanged: undefined
};

export default ListWrapper;
